export const accaTncTemplate = `<div class="auto-format">
    <p class="mat-h5">
      Demands and Needs and Suitability
    </p>
    <p>
      Our quotation(s) is (are) based on the information given by you in the online proposal form and any additional information provided. We understand that you require Insurance to cover exposure due to any breach of professional duty in connection with your business as a professional accountant meeting ACCA regulations. This policy provides the minimum cover requirement and meets the needs for accounts that are subject to ACCA regulations. This understanding, together with the information provided by you, has formed the basis of our discussions with insurers on your behalf.
    </p>
    <p>
      Please note all quotations are provided on a non-advised basis. We will not provide you with any advice, but will give you the information so you can decide if the policy meets your suitability requirements.
    </p>
    <p class="mat-h5 mt-3">
      Statement of Capacity, Markets Used and Earnings
    </p>
    <p>
      This statement confirms the capacity in which we are acting and how we made our selection of Insurers.
    </p>
    <p class="mat-h5 mt-3">
      Important information
    </p>
    <p>
      We have provided a Business Principles document which sets out the basis on which we agree to act for you as a client and contains details of our services to you. This includes a Limitation of Liability which is now a standard feature across our client relationships and reflects wider market practice. The following specific information is in relation to the policies of insurance you have asked us to arrange for you.
    </p>
    <p class="mat-h5 mt-5">
      ACCA Members Insurance Scheme
    </p>
    <p class="mat-h5 mt-3">
      The capacity in which we are acting
    </p>
    <p>
      In our dealings with you we will generally be acting as your agent but there are certain functions we may undertake on behalf of other parties such as insurers. In relation to the policies we arrange for you we detail below the capacity in which we act for certain key functions:
    </p>
    <div class="table my-1">
      <div class="row fw-b">
        <div class="col-6">Function</div>
        <div class="col-6">Capacity</div>
      </div>
      <div class="row">
        <div class="col-6">In selecting Insurers and policy coverage</div>
        <div class="col-6">We will act as your agent</div>
      </div>
      <div class="row">
        <div class="col-6">In placing the insurance</div>
        <div class="col-6">
          <p>We will act as your agent</p>
          <p>We also act as agent of the insurer</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6">In collecting and holding Premiums</div>
        <div class="col-6">We act as collecting agent for most insurers we deal with subject to Risk Transfer</div>
      </div>
      <div class="row">
        <div class="col-6">In the event of a claim</div>
        <div class="col-6">We will act as your agent</div>
      </div>
    </div>
    <p class="mat-h5 mt-3">
      How we made our selection of insurer
    </p>
    <p class="fw-b">
      We only offer cover under delegated authority facilities arranged by Lockton. We have therefore not approached any other markets.
    </p>
    <p class="mat-h5 mt-3">
      Our Earnings and Conflicts of Interest
    </p>
    <p>
      We are remunerated through commissions and ISB (Insurer Service Brokerage) paid to us by the insurer as a percentage of the premium charged. The ISB charge we make on the insurer is to reflect services for administration assistance we provide to them, e.g. issuing documents.
    </p>
    <p>
      Some of our remuneration may arise as a result of arrangements with insurers or others in arranging cover to meet your requirements, where we will also be remunerated by insurers or others under a services agreement to act in the capacity of their agent and owe duties to them in addition to you. In these situations we will take care to ensure that such conflicts of interest or any other conflicts that may arise in handling your insurances are properly managed so we continue to act in your best interests. Information on how we manage conflicts of interests is set out in our Business Principles.
    </p>
    <p>
      You are entitled, at any time to request information regarding the income we earn as a result of placing your insurance business.
    </p>
    <p class="mat-h5 mt-3">
      Claims and notifying any new matters
    </p>
    <p>
      We would draw your attention to the importance of the policy conditions regarding the notification of claims. You are obliged to notify your Insurers of actual claims and also any circumstances which may subsequently give rise to a claim against you. If you are in any doubt as to what constitutes a claims circumstance, please contact us for advice.
    </p>
    <p class="mat-h5 mt-3">
      The policy is a “claims made” policy and non renewal has important consequences
    </p>
    <p>
      Your policy is arranged on a ‘claims made’ basis, which means that it will cover you for claims or potential claims which you become aware of and notify to insurers during the policy period even though the original cause of such matters may have arisen years before.
    </p>
    <p>
      Therefore, any new claims or circumstances which may give rise to a claim against you notified after the expiry date will become matters for your new Insurers, or will need to be met by your own resources if alternative cover is not in place.
    </p>
    <p class="mat-h5 mt-3">
      Policy terms
    </p>
    <p>
      Your insurance policy contains terms which may be described as warranties, conditions precedent, subjectivities, conditions or exclusions.
    </p>
    <p class="fw-b">
      Regardless of how the terms of your policy are described you must always comply in full with the terms of your policy. If you do not, you risk being uninsured and not having your claims paid.
    </p>
    <p>
      It important that you review all of the terms of your policy to understand the obligations they impose on you and what you need to do in order to comply.
    </p>
    <p>
      It is also important that you understand any limitations that apply to your cover.
    </p>
    <p class="fw-b">
      If you do not understand the obligations the terms of your policy impose upon you, or what you need to do in order to comply, or what is excluded from cover, please ask us immediately.
    </p>
    <p class="mat-h5 mt-3">
      Warranties
    </p>
    <p>
      Warranties are terms in your policy by which you undertake to do or not do some particular thing, or that some condition will be fulfilled, or by which you confirm or deny the existence of a particular state of facts.
    </p>
    <p class="fw-b">
      Warranties must be exactly and literally complied with at all times to ensure that claims under your policy are paid.
    </p>
    <p>
      Generally, if you breach a warranty then the cover provided by your policy is suspended in full for the duration of the breach, so you will not have cover for any losses that arise during the period of the breach.
    </p>
    <p>
      Even if you remedy the breach of warranty, your policy will not provide cover in respect of losses that are “attributable to something happening” before the breach was remedied. Some breaches will not be capable of remedy.
    </p>
    <p class="fw-b">
      You should always comply with warranties in order to avoid a dispute over whether or not an insurer has to pay your claim.
    </p>
    <p>
      If a premium payment warranty has been imposed and you fail to pay the premium before the date specified (allowing sufficient time for us to receive and pass on the payment to your insurer) then the insurer may have reserved the right to cancel the contract automatically back to inception, or the policy may provide that cover is not in place for the period while the payment is outstanding.
    </p>
    <p class="mat-h5 mt-3">
      Conditions Precedent
    </p>
    <p>
      Your policy may contain terms known as “Conditions Precedent” which must be complied with either to ensure that the policy actually comes into force (e.g. paying the premium), or to ensure that the insurer will be liable for any claim (e.g. notifying the claim properly). Such terms are usually, but not always, described in the policy as Conditions Precedent. They may also be described as “Subjectivities”.
    </p>
    <p class="fw-b">
      You must comply with all Conditions Precedent in order to ensure that you have cover in place. Failure to do so might impact the ability to pay claims.
    </p>
    <p class="mat-h5 mt-3">
      Conditions
    </p>
    <p>
      A Condition specifies an obligation, usually in relation to your conduct during the term of the policy. Technically, breach of a condition gives rise to a claim in damages for breach of contract if the insurer can show they have suffered prejudice.
    </p>
    <p>
      However, given that
    </p>
    <ol>
      <li>
        Conditions may be Conditions Precedent, even if not described as such, and
      </li>
      <li>
        Breach of Conditions that reduce the risk of a loss and define the risk as a whole can be relied upon by insurers to deny liability for a claim.
      </li>
    </ol>
    <p class="fw-b">
      You must comply with all Conditions in order to ensure that you have cover in place. Failure to do so might impact the ability to pay claims.
    </p>
    <p class="mat-h5 mt-3">
      Exclusions
    </p>
    <p>
      Exclusions are terms of the policy which limit the scope of the insurer’s liability under the policy for claims in certain circumstances.
    </p>
    <p class="fw-b">
      You must carefully check the scope of all exclusions to ensure that your policy provides you with the cover you require for your risk.
    </p>
    <p class="mat-h5 mt-3">
      Subjectivities
    </p>
    <p>
      Where insurers list pre-inception subjectivities on your quotation form, you should be aware that insurers will not incept cover until the requisite information has been received, reviewed and accepted by them. Insurers can also include post-inception subjectivities in quotation forms and policy wordings. This means that insurers will incept cover for a specified time period on the condition that the information, or any act completed, before the expiry of that period. Should you not comply with the subjectivities, you risk your insurer avoiding any claims you make under the policy and potentially voiding your policy from inception.
    </p>
    <p class="mat-h5 mt-3">
      Cancellation
    </p>
    <p>
      This Policy may be cancelled by the Insured or the Insurers by giving 30 days’ notice via a Recorded Delivery letter to Lockton LLP, St Botolph Building 138 Houndsditch, London, EC3A 7AG. The Insured shall not be entitled to a pro rata return of premium from the date of cancellation if the cancellation takes effect less than six months after the start of the Period of Insurance. If the cancellation takes effect more than six months after the start of the Period of Insurance, any pro rata return of premium will be at Insurers’ discretion. No return of premium will be payable at any time if the Insured has notified Insurers of a claim or Circumstances which may give rise to a claim under this Policy. The Insured can cancel this Policy at any time.
    </p>
    <p class="mat-h5 mt-3">
      Terms of Business
    </p>
    <p>
      As part of our compliance procedure I am required to include our formal Business Principles. These are attached as a standalone document in the Documents repository. This Agreement explains how we conduct business, our complaints handling procedures, how we will protect your money and how we are remunerated. We would encourage you to read it. In addition, we bring to your attention, that we limit our liability to £5 million. Further information regarding our remuneration in respect of the enclosed quotation can be found in this section headed ‘Lockton Statement of Capacity, Markets and Earnings within this declaration.
    </p>
    
    
    
    
    
    
    


  </div>`;
